<template>
  <el-table
    style="width: 100%;"
    border
    :data="countTable"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      :prop="dataType != 'itemTag' ? 'skuId' : 'classifyName'"
      :label="firstColumnLabel"
      min-width="180"
      align="center"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip v-if="dataType == 'itemTag'" :content="row.classifyName" :lines="1" />
        <span v-else>{{ row.skuId }}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="skuName"
      :label="secondColumnLabel"
      min-width="180"
      align="center"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.skuName" :lines="1" />
      </template>
    </el-table-column>
    <el-table-column
      prop="frequencyInterval"
      label="购买频次"
      min-width="140"
      align="center"
    />
    <el-table-column
      prop="payCount"
      label="付款人数"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="payCountRatio"
      label="付款人数占比"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="tradeAmount"
      label="付款金额"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="tradeAmountRatio"
      label="付款金额占比"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="payTimes"
      label="付款单量"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="payTimesRatio"
      label="付款单量占比"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="payNum"
      label="付款件数"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="payNumRatio"
      label="付款件数占比"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="payAvgAmount"
      label="客单价"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="numAvgAmount"
      label="件单价"
      min-width="120"
      align="right"
    />
    <el-table-column
      prop="timesAvgAmount"
      label="笔单价"
      min-width="120"
      align="right"
    />
  </el-table>
</template>

<script>
import mixins from "../../../mixins/index.js";
import Empty from "../../../components/empty.vue";

export default {
  name: "BuyFrequencyTable",
  mixins: [mixins],
  components: {
    Empty,
    textOverflowTooltip: () => import("@/components/ai/components/prefabricateReport/components/textOverflowTooltip.vue"),
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    dataType: {
      type: String,
      default: "sku",
    },
    reportParams: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    countTable() {
      const ignoreKeys = ["skuId", "skuName", "classifyId", "classifyName", "frequencyInterval"];
      const tableData = Array.isArray(this.tableData) ? this.tableData : [];
      return tableData.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          if (ignoreKeys.includes(key)) {
            newRow[key] = row[key];
            return;
          }
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else {
            newRow[key] = this.formatNumber(row[key]);
          }
        });
        return newRow;
      });
    },
    firstColumnLabel() {
      const map = {
        sku: "skuId",
        spu: "商品Id",
        category: "类目Id",
        sellerCategory: "类目Id",
        itemTag: "标签分类",
      };
      return map[this.dataType] || "";
    },
    secondColumnLabel() {
      const map = {
        sku: "商品名称",
        spu: "商品名称",
        category: "类目名称",
        sellerCategory: "类目名称",
        itemTag: "标签名称",
      };
      return map[this.dataType] || "";
    },
    mergeColumnMap() {
      const columns = this.dataType != 'itemTag'
                      ? ['skuId', 'skuName']
                      : ['skuId', 'skuName', 'classifyId', 'classifyName'];
      return columns.reduce((prev, cur) => {
        prev[cur] = [ ...columns ];
        return prev;
      }, {});
    },
    spanData() {
      // const firstColProp = this.dataType != 'itemTag' ? 'skuId' : 'classifyName';
      // const secondColProp = 'skuName';
      // const firstRow = this.countTable[0] || {};
      // const isFirstRowTotal = firstRow[firstColProp] === firstRow[secondColProp] && firstRow[firstColProp] === '合计';
      const mergeMap = {};
      Object.keys(this.mergeColumnMap).forEach((prop) => {
        const posArr = [];
        let pos = 0;
        this.countTable.forEach((item, index) => {
          if (index === 0) {
            posArr.push(1);
            pos = 0;
          // } else if (isFirstRowTotal && index === 1) {
          //   posArr.push(1);
          //   pos = index;
          } else {
            let isSame = this.mergeColumnMap[prop].every((checkProp) => item[checkProp] === this.countTable[index - 1][checkProp]);
            if (isSame) {
              posArr[pos] += 1;
              posArr.push(0);
            } else {
              posArr.push(1);
              pos = index;
            }
          }
        });
        mergeMap[prop] = posArr;
      });
      return mergeMap;
    },
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // if (rowIndex == 0) {
      //   const firstColProp = this.dataType != 'itemTag' ? 'skuId' : 'classifyName';
      //   const secondColProp = 'skuName';
      //   const v1 = row[firstColProp];
      //   const v2 = row[secondColProp];
      //   if (v1 === v2 && v1 === '合计') {
      //     if (column.property === firstColProp) {
      //       return { rowspan: 1, colspan: 2 };
      //     }
      //     if (column.property === secondColProp) {
      //       return { rowspan: 1, colspan: 0 };
      //     }
      //     return { rowspan: 1, colspan: 1 };
      //   }
      // }
      if (this.mergeColumnMap[column.property]) {
        const rowspan = this.spanData[column.property][rowIndex] || 0;
        return {
          rowspan: rowspan,
          colspan: rowspan > 0 ? 1 : 0,
        };
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
};
</script>
